<section class="grey-M" *ngIf="viewType=='read' || viewType=='edit'">
    <div>
        <div class="col-lg-12" >
            <div class="pull-right" style="margin-right: 15px; margin-top: 10px; height: 23px;">
                <div *ngIf="viewType=='read'">
                <label style="padding-right:5px; width: auto;">Active</label>
                <label class="switch1" style="padding-right:10px;top:7px; width: auto;">
                  <input type="checkbox" #status
                    [checked]="!this.userForm.get('active').value"
                    (change)="confirmEnableDisable()">
                  <span class="slider round"></span>
                </label>
                <label style="padding-left:10px; width: auto;">Archived</label>  
            </div>     
          </div>
        </div>
  </div>
  <div>
    <div class="col-sm-12 form-group item-middle">
      <div class="col-sm-4">
        <img *ngIf="!this.userForm.get('logo').value?.url" src='assets/images/avatar.png' style="width: 82px;height: 82px;" class="img-circle img-responsive" alt=''>
      </div>    
        <div class="col-sm-6 admin-details-heading">
            <span class="admin-name">{{this.userForm.get('first_name').value}} {{this.userForm.get('last_name').value}}</span><br>
            <span class="admin-job-title">{{this.userForm.get('role').value?.desc}}</span>
        </div>
    </div>    
  </div>
</section>
<div #userContainer id="userContainer"  [ngClass]="viewType=='read' || viewType=='edit'? 'whiteTeacher': 'white'" class="form-inline">
     <ng-container *ngIf="!user_id && myRoleName">
        <p class="subtitle">
            You are about to add a new {{myRoleName}}
        </p>
    </ng-container>
    <ng-container *ngIf="user_id && myRoleName">
        <p class="subtitle">
            You are about to edit {{myRoleName}} details
        </p>
    </ng-container>
    <div class="loading" *ngIf="!loaded"></div>
    <form *ngIf="loaded" class="form-horizontal" enctype="multipart/form-data" [formGroup]=this.userForm>
        <div class="no-margin" *ngIf="!this.myrole">
            <div class="form-inline">
                <label class="required" for="role"><strong>Role</strong></label>
                <span class="pull-right">
                    <input type="text" class="form-control"
                        auto-complete
                        accept-user-input="false"
                        select-value-of="{{this.userForm.get('role').value?._id}}"
                        select-on-blur="true"
                        placeholder="Start typing to select Role"
                        formControlName="role"
                        (valueChanged)="roleChanged($event)"
                        [source]="this.roleListData"
                        [list-formatter]="myListFormatterForRole"
                        [value-formatter]="myValueFormatter"
                        required/>
                    <div *ngIf="this.userForm.get('role').dirty || this.userForm.get('role').touched">
                        <small *ngIf="this.userForm.get('role').errors || this.userForm.get('role').value === 'undefined' || this.userForm.get('role').value === ''">
                            <span class="alert">
                                <i class="glyphicon glyphicon-alert "></i> No match found in the system.</span>
                        </small>
                    </div>
                </span>
            </div>
            <hr>
        </div>
        <div class="no-margin" style="padding-bottom: 1px;" *ngIf="viewType=='read'">
            <div class="form-inline">
                <label style="color:#666;">Role </label>
                <div class="pull-right">
                        <label style="width:250px; color:#333333;">{{this.userForm.get('role').value?.desc}}</label>
                        <a (click)="edit()" class="edit">
                            <i class="glyphicon glyphicon-pencil"></i>
                            &nbsp;&nbsp;Edit Details
                        </a>
                    </div>
            </div>
        </div>
        <div class="no-margin" style="padding-bottom: 1px;" *ngIf="viewType=='read'">
            <div class="form-inline">
                <label style="color:#666;">Key subject </label>
                <div class="pull-right">
                        <label style="width:324px; color:#333333;">{{this.userForm.get('key_subject').value?.name}}</label>
                </div>
            </div>
        </div>
        <div class="no-margin" style="padding-bottom: 1px;" *ngIf="viewType=='read'">
            <div class="form-inline">
                <label style="color:#666;">Gender </label>
                <div class="pull-right">
                        <label style="width:324px; color:#333333;">{{this.userForm.get('gender').value}}</label>
                </div>
            </div>
        </div>
        <div class="no-margin" style="padding-bottom: 1px;" *ngIf="viewType=='read'">
            <div class="form-inline">
                <label style="color:#666;">Email </label>
                <div class="pull-right">
                        <label style="width:324px; color:#333333;">{{this.userForm.get('contact.email').value}}</label>
                </div>
            </div>
        </div>
        <div class="no-margin" *ngIf="viewType!='read'">
            <div class="form-inline">
                <label class="label600" style="font-size:11px; color: #666666;">First Name</label>
                <span class="pull-right">
                <input type="text" class="form-control" formControlName="first_name" placeholder="{{'Insert first name(s)' | translate}}" (change)="nameChanged($event)">
                <div *ngIf="this.userForm.get('first_name').invalid && (this.userForm.get('first_name').dirty || this.userForm.get('first_name').touched)">
                    <small *ngIf="this.userForm.get('first_name').errors || this.userForm.get('first_name').errors?.required">
                        <span class="alert">Please enter first name.</span>
                    </small>
                </div>
                </span>
            </div>
        </div>

        <div class="no-margin" *ngIf="viewType!='read'">
            <div class="form-inline">
                <label class="label600" style="font-size:11px; color: #666666;">Surname</label>
                <span class="pull-right">
                <input type="text" class="form-control" formControlName="last_name" placeholder="{{'Insert surname' | translate}}" (change)="nameChanged($event)">

        <div *ngIf="this.userForm.get('last_name').invalid && (this.userForm.get('last_name').dirty || this.userForm.get('last_name').touched)">
                <small *ngIf="this.userForm.get('last_name').errors || this.userForm.get('last_name').errors?.maxlength">
                    <span class="alert">Please enter surname.</span>
                </small>
            </div>
            </span>
            </div>
        </div>

        <div class="no-margin" *ngIf="this.myrole && this.myrole === 'Teacher' && viewType!='read'">
            <div class="form-inline">
                <label class="label600">Key subject</label>
                <span class="pull-right">
                    <select #gr class="form-control" formControlName="key_subject" style="width: 326px;"  (change)="formChanged($event)"[dir]="textDir" >
                        <option value="" [selected]="!this.userForm.get('key_subject').value?.name">Select</option>
                        <option *ngFor="let items of subjectsListData" [selected]="this.userForm.get('key_subject').value?.name == items?.name" value="{{items?._id}}">
                            {{items?.name}}
                        </option>
                    </select>
                </span>
            </div>
        </div>
        <div class="no-margin" *ngIf="this.myrole && (this.myrole === 'Teacher' || this.myrole === 'SchoolAdmin') && viewType!='read'" style="margin-top: 25px; margin-bottom: 25px;">
            <div class="form-inline">

                <div class="sm-12 marT20 flexStart">
                    <div class="labelwid"> <label class="left">Gender</label></div>
                    <div class="txtW">
                        <div style="width: 150px;margin-right:130px;" *ngIf="viewType === 'add'">
                            <ngx-select-dropdown [multiple]="false" formControlName="gender" [options]="genderList" [config]="genderSelectConfig" (change)="formChanged($event)"></ngx-select-dropdown>
                        </div>
                        <div style="width: 150px;margin-right:130px;" *ngIf="viewType === 'edit'">
                            <ngx-select-dropdown [multiple]="false" formControlName="gender" [options]="genderList" [config]="genderSelectConfig" (change)="formChanged($event)"></ngx-select-dropdown>
                        </div>
                    </div>
                </div>







               <!--  <label style="font-size:11px; color: #666666;">Gender</label>
                <span style="margin-left: 102px;">
                <select class="form-control" formControlName="gender" (change)="formChanged($event)">
                    <option value="" [selected]="!this.userForm.get('gender').value?.name">Select</option>
                    <option [selected]="this.userForm.get('gender').value?.name == 'male'" value="male"> Male</option>
                    <option [selected]="this.userForm.get('gender').value?.name == 'female'" value="female">Female</option>
                </select>
                </span> -->
            </div>
        </div>
        <div class="no-margin" *ngIf="this.myrole && this.myrole === 'Student'">
            <div class="form-inline">
                <label><strong>Date of birth</strong></label>
                <span class="pull-right">
                    <input type="hidden" formControlName="date_of_birth">
                    <input id="dob" data-provide="datepicker" data-date-format="yyyy-mm-dd" type="text"
                        class="form-control datepicker" placeholder="Example: 2016-4-28"  (change)="formChanged($event)">
                </span>
            </div>
            <hr>
        </div>

        <div class="no-margin" *ngIf="this.myrole && this.myrole === 'Student'">
            <div class="form-inline" formGroupName="address">
                <label><strong>Address</strong></label>
                <span class="pull-right">
                <input type="text" class="form-control" formControlName="addr1" placeholder="Insert address"  (change)="formChanged($event)">
                </span>
            </div>
            <hr>
        </div>

        <div class="no-margin" *ngIf="this.myrole && this.myrole == 'Student'">
            <div class="form-inline">
                <label class="required"><strong>Grade</strong></label>
                <span class="pull-right">
                <select #gr class="form-control" formControlName="grade" style="width: 260px;" (change)="populateClass('grade', gr.value)" [dir]="textDir">
                    <option value="">Grade</option>
                    <option *ngFor="let item of gradeListData" value="{{item?._id}}">
                        {{item?.name}}
                    </option>
                </select>
                </span>
            </div>
            <hr>
        </div>

        <div class="no-margin" *ngIf="this.myrole && this.myrole === 'Student' && this.classListData">
            <div class="form-inline">
                <label class="required"><strong>Class</strong></label>
                <span class="pull-right">
                <select formControlName="class" class="form-control" [dir]="textDir">
                    <option value="">Class</option>
                    <option *ngFor="let item of classListData" value="{{item?._id}}">
                        {{item?.name}}
                    </option>
                </select>
                </span>
            </div>
            <hr>
        </div>

        <div class="no-margin" *ngIf="(this.myrole &&
            (
                this.myrole === 'ProjectAdmin' ||
                this.myrole === 'ContentProvider'
            ))">
            <div class="form-inline">
                <label class="required" for="partner"><strong>Partner</strong></label>
                <span class="pull-right">
                    <input type="text"
                        class="form-control"
                        auto-complete
                        accept-user-input="false"
                        select-value-of="{{this.userForm.get('partner').value?._id}}"
                        min-chars="1"
                        max-num-list = "5"
                        select-on-blur="true"
                        placeholder="Start typing to select Partner "
                        formControlName="partner"
                        loading-text="loading..."
                        [source]="this.partnerListData"
                        [list-formatter]="myListFormatter"
                        [value-formatter]="myValueFormatter"
                        (change)="formChanged($event)"
                        required/>
                    <div *ngIf="this.userForm.get('partner').dirty || this.userForm.get('partner').touched">
                        <small *ngIf="this.userForm.get('partner').errors || this.userForm.get('partner').value === 'undefined' || this.userForm.get('partner').value === ''">
                            <span class="alert">
                                <i class="glyphicon glyphicon-alert "></i> No match found in the system.</span>
                        </small>
                    </div>
                </span>
            </div>
            <hr>
        </div>

        <div class="no-margin" *ngIf="viewType!='read'">
            <div class="form-inline" formGroupName="contact">
                <label class="label600" style="font-size:11px; color: #666666;">Email address</label>
                <span class="pull-right">
                <input type="text" formControlName="email" class="form-control" placeholder="Example: claire.whyte@school.org"  (change)="formChanged($event)">

                <div *ngIf="this.userForm.get('contact.email').invalid && (this.userForm.get('contact.email').dirty || this.userForm.get('contact.email').touched)">
                    <small *ngIf="this.userForm.get('contact.email').errors && this.userForm.get('contact.email').errors?.pattern">
                        <span class="alert">
                            <i class="glyphicon glyphicon-alert"></i> Enter valid email address</span>
                    </small>
                </div>
                </span>
            </div>
        </div>
        <div class="no-margin" *ngIf="this.myrole && this.myrole === 'Teacher' && viewType!='read'">
            <div class="form-inline" formGroupName="contact">
                <label class="label600">School</label>
                <span>
                    <label class="label600" style="margin-left:60px;">{{this.school_name}}</label>
                </span>
            </div>
        </div>
        <div class="alert alert-success" *ngIf="this.myrole === 'Teacher' && viewType!='read' && viewType!='edit'">
            <ng-container *ngIf="user_id && !userForm.controls.username?.value">
                <a class="btn btn-link" (click)="this.generateUserPass()">Click Here to Generate username and password</a>
            </ng-container>
            <div *ngIf="this.userForm.get('username').value">
                <label class="label600">Username</label>
                <label class="grey-txt pull-right">{{this.userForm.get("username").value}}</label>
            </div>
            <div *ngIf="this.userForm.get('password').value">
                <label class="label600">Password</label>
                <label class="grey-txt pull-right">{{this.userForm.get("password").value}}</label>
            </div>
        </div>
        <div class="no-margin" style="padding-bottom: 1px;" *ngIf="viewType=='read'">
            <div class="form-inline">
                <label style="color:#666;">Username </label>
                <div class="pull-right">
                        <label style="width:324px; color:#333333;">{{this.userForm.get('username').value}}</label>
                </div>
            </div>
        </div>
        <div class="no-margin" style="padding-bottom: 1px;" *ngIf="viewType=='read'  && newPassword ==''">
            <div class="form-inline">
                <label style="color:#666;">Password </label>
                <div class="pull-right">
                        <label style="width:324px; color:#333333;">{{this.userForm.get('password').value}}</label>
                </div>
            </div>
        </div>
        <div class="no-margin" style="padding-bottom: 1px;" *ngIf="viewType=='read' && newPassword !=''">
            <div class="form-inline">
                <label style="color:green;">Password</label>
                <div class="pull-right">
                        <label style="width:324px; color:green;">{{newPassword}}</label>
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
    </form>
</div>